import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { Edges, VIEWPORTS } from '../../../styles/Grid/GridSizes';
import { MediaQueries } from '../../../styles/Grid';

const selectedButtonStyles = {
  color: colorsPalette.red,
  borderBottom: `2px solid ${colorsPalette.red}`,
};

export const containerCss = css({
  position: 'sticky',
  top: 0,
  backgroundColor: colorsPalette.white,
  borderBottom: `1px solid ${colorsPalette.grey10}`,
  zIndex: 3,
  [MediaQueries.lgAndUp]: {
    position: 'fixed',
    top: 0,
    width: '100%',
    transform: 'translateY(-100%)',
    transition: 'transform 0.3s',
  },
});

export const containerExtraCss = css({
  [MediaQueries.xl]: {
    maxWidth: 'none',
  },
});

export const contentCss = css({
  [MediaQueries.lgAndUp]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const stickyShownDesktopCss = css({
  [MediaQueries.lgAndUp]: {
    transform: 'translateY(0)',
  },
});

export const buttonsContainerCss = css({
  overflow: 'auto',
  whiteSpace: 'nowrap',
  marginLeft: -Edges[VIEWPORTS.sm],
  marginRight: -Edges[VIEWPORTS.sm],
  padding: `0 ${Edges[VIEWPORTS.sm]}px`,

  '::-webkit-scrollbar': {
    display: 'none',
  },
});

export const scrollContainerCss = css({
  height: '100%',
});

export const buttonCss = css(typography.effra18, {
  color: colorsPalette.grey60,
  padding: 0,
  border: 0,
  borderBottom: `2px solid ${colorsPalette.transparent}`,
  backgroundColor: colorsPalette.transparent,
  outline: 'none',
  cursor: 'pointer',
  height: 52,
  fontWeight: fontWeights.medium,
  margin: '0 17px',
  lineHeight: 1,
  [MediaQueries.mdAndUp]: {
    height: 72,
  },
  [MediaQueries.lgAndUp]: {
    height: '100%',
  },

  '&:first-of-type': {
    marginLeft: 0,
  },

  '&:last-child': {
    marginRight: 0,
  },

  '&:hover': {
    ...selectedButtonStyles,
    borderBottomColor: colorsPalette.transparent,
  },
});

export const selectedButtonCss = css({
  '&, &:hover': {
    ...selectedButtonStyles,
  },
});

export const heroButtonsContainerCss = css({
  backgroundColor: colorsPalette.white,
  bottom: 0,
  left: 0,
  padding: `19px ${Edges[VIEWPORTS.sm]}px`,
  position: 'fixed',
  transition: 'transform 0.3s',
  width: '100%',
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    flexDirection: 'row-reverse',
    transform: 'translateY(100%)',
  },
  [MediaQueries.lgAndUp]: {
    marginRight: -80,
    flex: '0 0 400px',
    position: 'relative',
    transform: 'none',
  },
});

export const oneButtonContainerCss = css({
  [MediaQueries.lgAndUp]: {
    flex: '0 0 200px',
  },
});

export const showHeroButtonsCss = css({
  [MediaQueries.mdAndUp]: {
    transform: 'translateY(0)',
  },
});

export const heroButtonsContentCss = css({
  display: 'flex',
  height: '100%',
  justifyContent: 'space-between',
  '*:last-child': {
    [MediaQueries.mdAndUp]: {
      marginRight: 0,
    },
  },
  '> a, button': {
    minHeight: 56,
    height: '100%',
    [MediaQueries.mdAndUp]: {
      width: 258,
    },
  },
  [MediaQueries.mdAndUp]: {
    minWidth: 532,
  },
});

export const getInTouchCss = css({
  marginRight: 20,
  width: '100%',
  [MediaQueries.mdAndUp]: {
    marginRight: 0,
    width: 258,
  },
  ['a']: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100%',
    [MediaQueries.lgAndUp]: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      padding: '20px 24px',
    },
  },
});

export const oneButtonContentCss = css({
  justifyContent: 'flex-end',
  'button, a': {
    width: '50%',
  },
  [MediaQueries.mdAndUp]: {
    'button, a': {
      width: '100%',
    },
    minWidth: 200,
  },
});
